import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, dashboardForRole } from "../lib/auth";
import { toast } from "sonner";
import AuthShell, { Field, Input } from "../components/AuthShell";

const ROLE_META = {
  customer: { title: "Customer Sign In", subtitle: "Track bookings · AI recommendations", placeholder: "Email" },
  agent:    { title: "Salon Staff",      subtitle: "Front desk team",                       placeholder: "Email or username" },
  receptionist: { title: "Reception",    subtitle: "Bookings · WhatsApp · Schedule",        placeholder: "Email or username" },
  owner:    { title: "Site Owner",       subtitle: "Glazy · Salon Operations",              placeholder: "Username (e.g. Glazy)" },
  admin:    { title: "Admin",            subtitle: "DarkWebx03 · Approval Console",         placeholder: "Username (e.g. darkwebx03)" },
};

export default function RoleLogin({ role }) {
  const meta = ROLE_META[role] || ROLE_META.customer;
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(identifier, password);
      const wanted = role;
      // Validate the user signed in matches the page they came from
      if (wanted === "customer" && u.role !== "customer") {
        toast.error(`This portal is for customers only. You are ${u.role}.`);
        nav(dashboardForRole(u.role));
        return;
      }
      if (wanted !== "customer" && u.role !== wanted && u.role !== "admin") {
        toast.error(`This portal expects ${wanted} role. You signed in as ${u.role}.`);
        nav(dashboardForRole(u.role));
        return;
      }
      toast.success(`Welcome, ${u.name}`);
      nav(dashboardForRole(u.role));
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title={meta.title} subtitle={meta.subtitle} footer={<Link to="/" className="hover:text-[var(--accent)]">← Back to site</Link>}>
      <form onSubmit={submit} className="space-y-4" data-testid={`login-${role}-form`}>
        <Field label={meta.placeholder}>
          <Input required value={identifier} onChange={e=>setIdentifier(e.target.value)} data-testid={`login-${role}-identifier`} placeholder={meta.placeholder} />
        </Field>
        <Field label="Password">
          <Input type="password" required value={password} onChange={e=>setPassword(e.target.value)} data-testid={`login-${role}-password`} />
        </Field>
        <button type="submit" disabled={loading}
          className="btn-gold w-full rounded-full py-3 text-sm tracking-widest uppercase disabled:opacity-60" data-testid={`login-${role}-submit`}>
          {loading ? "Signing in..." : "Sign In"}
        </button>
        {role === "customer" && (
          <div className="flex items-center justify-between text-xs pt-2">
            <Link to="/signup" className="text-[var(--muted)] hover:text-[var(--accent)] uppercase tracking-widest">Create account</Link>
            <Link to="/forgot-password" className="text-[var(--muted)] hover:text-[var(--accent)] uppercase tracking-widest" data-testid="forgot-link">Forgot password?</Link>
          </div>
        )}
        {role !== "customer" && (
          <p className="text-[10px] text-center text-[var(--muted)] uppercase tracking-widest pt-2">
            Forgot your password? Contact the site owner.
          </p>
        )}
      </form>
    </AuthShell>
  );
}
